import "./App.css";
import { Route, Routes } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import { ROUTE_PATH } from "./helper/Constants";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Admin from "./pages/Admin/Admin";
import Header from "./components/Header/Header";
import { useDispatch } from "react-redux";
import { sagaActions } from "./redux/sagas/sagaActions";
import axios from "axios";
import Login from "./pages/Login/Login";
import { getSessionStorage } from "./helper/Storage";
import AppQRcode from "./pages/AppQRcode/AppQRcode";
import { useEffect } from "react";

const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#ffc115cb",
    },
  },
});

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    axios.interceptors.request.use((config) => {
      const accessToken = getSessionStorage("token");
      if (accessToken) {
        config.headers["authorization"] = `Bearer ${accessToken}`;
      }
      dispatch({ type: sagaActions.API_CALL_START });
      return config;
    });
    axios.interceptors.response.use((config) => {
      dispatch({ type: sagaActions.API_CALL_END });
      return config;
    });
  }, [dispatch]);

  return (
    <div className="App">
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <ScrollToTop />
        <Header></Header>
        <div className="app-container">
          <Routes>
            <Route path={ROUTE_PATH.BASE} element={<Login />} />
            <Route path={ROUTE_PATH.HOME} element={<Admin />} />
            <Route path={ROUTE_PATH.QRCODE} element={<AppQRcode />} />
            <Route
              path={ROUTE_PATH.PRODUCT_DETAILS + ":id/:type"}
              element={<ProductDetails />}
            />
            <Route
              path="*"
              element={
                <div>
                  <h1>404 Not Found</h1>
                </div>
              }
            />
          </Routes>
        </div>
      </ThemeProvider>
    </div>
  );
};

export default App;
